<h2>Dokument suchen</h2>

<div class="searchbar-container">
  <div class="searchbar-items">
    <input
      [(ngModel)]="query"
      placeholder="Suche..."
      class="suchFeld"
      (keyup.enter)="search()"
    />
  </div>
  <div class="searchbar-items">
    <button (click)="search()"><b>Suchen</b></button>
  </div>
</div>

<div class="search-container">
  <div class="search-items">
    <b>Dokumenttyp:</b><br />
    <li *ngFor="let type of allDocumentTypes">
      <input
        type="checkbox"
        (change)="toggleType(type)"
        [checked]="selectedTypes.includes(type)"
        [disabled]="!allTypeOptions.has(type)"
        [id]="'typ-' + type"
      />
      <label [for]="'typ-' + type">&nbsp;{{ type }}</label>
    </li>
    <br />
    <b>Schlagwörter:</b><br />
    <div *ngIf="selectedTags.length > 0">
      <div *ngFor="let tag of selectedTags" class="tag-container">
        {{ tag }}
        <span (click)="removeTag(tag)" class="remove-x">✖</span>
      </div>
    </div>

    <input
      list="tags"
      name="tags"
      [(ngModel)]="currentTag"
      (keyup.enter)="addTag()"
      (change)="addTag()"
    />

    <datalist id="tags">
      <option *ngFor="let opt of sortedTags" [value]="opt"></option>
    </datalist>
    <br />

    <b>Norm:</b><br />

    <div *ngIf="selectedNorms.length > 0">
      <div *ngFor="let norm of selectedNorms" class="tag-container">
        {{ norm }}
        <span (click)="removeNorm(norm)" class="remove-x">✖</span>
      </div>
    </div>

    <input
      list="norm"
      name="norm"
      [(ngModel)]="currentNorm"
      (keyup.enter)="addNorm()"
      (change)="addNorm()"
    />

    <datalist id="norm">
      <option *ngFor="let opt of allNormwords" [value]="opt"></option>
    </datalist>
    <br />

    <br />
    <b>Quelle / Gericht:</b><br />
    <li *ngFor="let quelle of allQuellen">
      <input
        type="checkbox"
        (change)="toggleQuelle(quelle)"
        [checked]="selectedQuelle.includes(quelle)"
        [id]="'quelle-' + quelle"
        [disabled]="!allQuelleOptions.has(quelle)"
      />
      <label [for]="'quelle-' + quelle">&nbsp;{{ quelle }}</label>
    </li>
  </div>

  <!-- Suchergebnisse -->
  <div class="results-container">
    <div *ngIf="isLoading" class="loading">Suche läuft...</div>
    <div *ngIf="hasLoaded && !isLoading && filteredResults.length === 0" class="no-results">
      Keine Ergebnisse gefunden.
    </div>
    <div *ngIf="!isLoading && filteredResults.length > 0" class="results-info">
      {{ filteredResults.length }} Ergebnisse gefunden.
      Sortieren nach:
      <select [(ngModel)]="searchOrder" name="sort" id="sort" (change)="sortResults(); changePage(1)">
        <option value="created">Erstelldatum</option>
        <option value="score">Relevanz</option>
        <option value="date">Erkenntnisdatum</option>
      </select>
    </div>
    <div *ngIf="!isLoading && filteredResults.length > 0" class="results-info">
      Seite {{ currentPage }} von {{ totalPages }}
      (Ergebnisse {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, filteredResults.length) }})
    </div>
    <div
      *ngFor="let result of paginatedResults"
      class="result-item"
    >
      <a target="_blank" [href]="result.url">
        <span>
          <b [innerHTML]="highlightText(result.title)"></b>
        </span>
      </a>
      <span *ngIf="!result.publiziert" class="draft-text">
        [Entwurf]
      </span>
      <br />
      <span class="text_grau">
        Angelegt am {{ formatDate(result.dateCreated) }}
      </span>
      <span class="text_grau" *ngIf="result.dateModified != result.dateCreated">
        - letzte Änderung am {{ formatDate(result.dateModified) }}
      </span>
      <br />
      <span class="text_grau">
        Typ: {{ result.type }}<br/>
        Quelle / Gericht: {{ result.quelle }}<br/>
        Geschäftszahl: {{ result.geschaeftszahl }}<br/>
      </span>
      <br />
      <span [innerHTML]="highlightText(truncateText(result.zusammenfassung))"></span>
      <br /><br />
      <span *ngIf="result.keywords.length > 0">
        <b>{{ result.keywords.join(", ") }}</b>
      </span>
      <span *ngIf="result.docUrl != result.url">
        <a target="_blank" [href]="result.docUrl">Zum übergeordneten Dokument &gt;&gt;</a>
      </span>
      <br />
    </div>
    <!-- Pagination controls -->
    <div class="pagination" *ngIf="totalPages > 1">
      <button
        [disabled]="currentPage === 1"
        (click)="changePage(currentPage - 1)"
        class="page-button"
      >
        &#8592;
      </button>
      <button
        *ngFor="let page of pageNumbers"
        [class.active]="page === currentPage"
        (click)="changePage(page)"
        class="page-button"
      >
        {{ page }}
      </button>
      <button
        [disabled]="currentPage === totalPages"
        (click)="changePage(currentPage + 1)"
        class="page-button"
      >
        &#8594;
      </button>
    </div>
  </div>
</div>
